<template>
  <svg
    v-if="type === 'ios' || type === 'Mac OS' || type === 'iOS'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    style="margin: 1px 0 -1px"
  >
    <g>
      <path
        d="M10.9993 0C10.1463 0.0589997 9.14933 0.604996 8.56833 1.31599C8.03834 1.96099 7.60234 2.91898 7.77234 3.84998C8.70433 3.87898 9.66732 3.31998 10.2253 2.59698C10.7473 1.92399 11.1423 0.971994 10.9993 0Z"
        fill="currentColor"
      />
      <path
        d="M14.3703 5.36799C13.5513 4.34099 12.4003 3.745 11.3133 3.745C9.87832 3.745 9.27133 4.43199 8.27433 4.43199C7.24634 4.43199 6.46534 3.747 5.22435 3.747C4.00536 3.747 2.70736 4.49199 1.88437 5.76598C0.727376 7.55997 0.925374 10.933 2.80036 13.8059C3.47136 14.8339 4.36735 15.9899 5.53935 15.9999C6.58234 16.0099 6.87634 15.3309 8.28933 15.3239C9.70232 15.3159 9.97032 16.0089 11.0113 15.9979C12.1843 15.9889 13.1293 14.7079 13.8003 13.6799C14.2813 12.9429 14.4603 12.5719 14.8333 11.7399C12.1203 10.707 11.6853 6.84898 14.3703 5.36799Z"
        fill="currentColor"
      />
    </g>
  </svg>
  <svg
    v-else-if="type === 'android' || type === 'Android'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <path
        d="M2.2211 5.18268C1.94542 5.18268 1.71152 5.27881 1.51924 5.47109C1.32697 5.66336 1.2308 5.89408 1.2308 6.16336V10.2979C1.2308 10.574 1.32694 10.8077 1.51924 11C1.71152 11.1922 1.94542 11.2884 2.2211 11.2884C2.49658 11.2884 2.72906 11.1923 2.91835 11C3.10727 10.8077 3.20199 10.574 3.20199 10.2979V6.16336C3.20199 5.89405 3.10585 5.66336 2.91355 5.47109C2.72125 5.27881 2.49038 5.18268 2.2211 5.18268Z"
        fill="currentColor"
      />
      <path
        d="M10.1827 1.47103L10.8654 0.211621C10.9102 0.128243 10.8943 0.0643063 10.8175 0.0193481C10.7341 -0.0194188 10.67 0.00022502 10.6252 0.0768911L9.93294 1.34637C9.32381 1.07705 8.67955 0.942147 8.00018 0.942147C7.32066 0.942147 6.67634 1.07708 6.06744 1.34637L5.37516 0.0768911C5.33017 0.00022502 5.26609 -0.0192453 5.18289 0.0193481C5.10588 0.0645088 5.08994 0.128243 5.13492 0.211621L5.81765 1.47103C5.12537 1.82407 4.57402 2.31574 4.16378 2.94712C3.75354 3.57885 3.54834 4.26919 3.54834 5.01936H12.4424C12.4424 4.26937 12.2371 3.579 11.8269 2.94712C11.4166 2.31574 10.8685 1.82407 10.1827 1.47103ZM6.23564 3.30285C6.16181 3.37686 6.07363 3.41369 5.97113 3.41369C5.86843 3.41369 5.78204 3.37686 5.71157 3.30285C5.64109 3.2292 5.60585 3.14136 5.60585 3.03852C5.60585 2.93601 5.64109 2.84801 5.71157 2.77418C5.78204 2.70052 5.86863 2.66369 5.97113 2.66369C6.07363 2.66369 6.16181 2.70052 6.23564 2.77418C6.3093 2.84818 6.3463 2.93601 6.3463 3.03852C6.3461 3.14119 6.30913 3.2292 6.23564 3.30285ZM10.2884 3.30285C10.2178 3.37686 10.1312 3.41369 10.0289 3.41369C9.92614 3.41369 9.83799 3.37686 9.76431 3.30285C9.69051 3.2292 9.65368 3.14136 9.65368 3.03852C9.65368 2.93601 9.69051 2.84801 9.76431 2.77418C9.83799 2.70052 9.92614 2.66369 10.0289 2.66369C10.1314 2.66369 10.2178 2.70052 10.2884 2.77418C10.3589 2.84818 10.3941 2.93601 10.3941 3.03852C10.3941 3.14119 10.3589 3.2292 10.2884 3.30285Z"
        fill="currentColor"
      />
      <path
        d="M3.58655 11.7691C3.58655 12.0642 3.68905 12.3141 3.89408 12.5191C4.09928 12.7241 4.34913 12.8266 4.64408 12.8266H5.35565L5.3654 15.0096C5.3654 15.2852 5.46154 15.5193 5.65381 15.7116C5.84608 15.9039 6.07698 16 6.34609 16C6.6216 16 6.85565 15.9039 7.04795 15.7116C7.24025 15.5193 7.33639 15.2852 7.33639 15.0096V12.8268H8.66326V15.0096C8.66326 15.2852 8.75936 15.5193 8.95167 15.7116C9.14397 15.9039 9.37781 16 9.65352 16C9.92903 16 10.1631 15.9039 10.3554 15.7116C10.5477 15.5193 10.6438 15.2852 10.6438 15.0096V12.8268H11.365C11.6534 12.8268 11.9 12.7243 12.1054 12.5193C12.3104 12.3142 12.413 12.0644 12.413 11.7693V5.36517H3.58655V11.7691Z"
        fill="currentColor"
      />
      <path
        d="M13.7789 5.18268C13.5096 5.18268 13.2789 5.2774 13.0866 5.46631C12.8943 5.65558 12.7982 5.88806 12.7982 6.16336V10.2979C12.7982 10.574 12.8943 10.8077 13.0866 11C13.2789 11.1923 13.5098 11.2884 13.7789 11.2884C14.0544 11.2884 14.2885 11.1923 14.4808 11C14.6731 10.8077 14.7692 10.574 14.7692 10.2979V6.16336C14.7692 5.88803 14.6731 5.65558 14.4808 5.46631C14.2885 5.2774 14.0544 5.18268 13.7789 5.18268Z"
        fill="currentColor"
      />
    </g>
  </svg>
  <svg
    v-else
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.571429 13.7143H15.4286C15.7441 13.7143 16 13.4584 16 13.1428V12.5714H0V13.1428C0 13.4584 0.255859 13.7143 0.571429 13.7143Z"
      fill="currentColor"
    />
    <path d="M1.14285 2.28571H14.8571V11.4286H1.14285V2.28571Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'IconDevices',
  props: {
    type: String,
  },
}
</script>

<style scoped></style>
